module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/babel-runtime/core-js/get-iterator.js
 ** module id = 915
 ** module chunks = 0
 **/